(ns frontend.view.grid.transaction-processes-grid.columns)

;;columns shown by default, in order. Anticipated decision date (not closing
;;date) is the default anticipated-date column: it's mandatory for 3 of the 4
;;transaction types (initial-investment / follow-on / mip) and collected early,
;;so it's populated on nearly every process — whereas the closing date is only
;;mandatory for initial-investment and is blank on most rows.
(def ordered-default-columns
  [:transaction-process/short-name
   :transaction-process/vehicle
   :transaction-process/stage
   :transaction-process/status
   :common/created-on
   :transaction-process/anticipated-decision-date])

(def default-columns
  (set ordered-default-columns))

;;the selectable column universe is derived from the entity schema (every
;;grid-renderable, non-hidden, role-readable TP field, plus :common/created-on)
;;in events/column-keys — so custom views can use any field the tenant has
;;enabled and the user can access, like the other entity grids.

;;always selected, cannot be removed
(def mandatory?
  #{:transaction-process/short-name})
